import { useSearchParams } from "react-router-dom";
import { useDash } from "./ctx";
import Feedback from "./Feedback";
import ProductSignals from "./ProductSignals";

const PLATFORM = ["super_admin", "platform_admin", "onboarding_admin"];

// iter451 — the platform Feedback view now hosts what used to be "Product signals" as a
// Feature-requests tab. Community/portfolio feedback (with a tenant in context) is unchanged.
export default function FeedbackHub() {
  const { role, actualRole, tenantId } = useDash();
  const isPlatform = PLATFORM.includes(actualRole || role) && !tenantId;
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "requests" ? "requests" : "feedback";
  const go = (k) => setSp(k === "feedback" ? {} : { tab: k });
  if (!isPlatform) return <Feedback />;
  return (
    <div className="space-y-5">
      <div className="inline-flex rounded-full bg-sand-100 border border-sand-200 p-1" data-testid="feedback-tabs">
        {[["feedback", "Feedback"], ["requests", "Feature requests"]].map(([k, l]) => (
          <button key={k} type="button" data-testid={`feedback-tab-${k}`} onClick={() => go(k)}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${tab === k ? "bg-ink text-white shadow-sm" : "text-ink/60 hover:text-ink"}`}>{l}</button>
        ))}
      </div>
      {tab === "requests" ? <ProductSignals /> : <Feedback />}
    </div>
  );
}
